<div class="error-page">
  <div class="wrapper">
    <h1 class="title">404</h1>
    <h2 class="title">Error</h2>
    <h3>Page not found</h3>
    <button [routerLink]="'/'" color="primary" mat-raised-button>Back</button>
  </div>
</div>
